import React from "react";
import { observer } from "mobx-react";
import { SignedEditionSadaicWorkflowStateUpdateStore } from "../../store";
import { SignedEditionSadaicWorkflowStateUpdateForm } from "./SignedEditionSadaicWorkflowStateUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type SignedEditionSadaicWorkflowStateUpdateProps = {
  signedEditionSadaicWorkflowStateUpdateStore: SignedEditionSadaicWorkflowStateUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const SignedEditionSadaicWorkflowStateUpdate: React.FC<SignedEditionSadaicWorkflowStateUpdateProps> =
  observer(
    ({
      signedEditionSadaicWorkflowStateUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={signedEditionSadaicWorkflowStateUpdateStore.isSaving}
          />
          <OutdatedAfterSaveNotice
            open={signedEditionSadaicWorkflowStateUpdateStore.savedButOutdated}
            onReload={() =>
              signedEditionSadaicWorkflowStateUpdateStore.reloadSignedEditionSadaicWorkflowState()
            }
            reloadDisabled={
              signedEditionSadaicWorkflowStateUpdateStore.isProcessing
            }
          />
          <SignedEditionSadaicWorkflowStateUpdateForm
            signedEditionSadaicWorkflowStateUpdateStore={
              signedEditionSadaicWorkflowStateUpdateStore
            }
            name_esError={
              signedEditionSadaicWorkflowStateUpdateStore.errors.name_es
                ?.message
            }
            onName_esChange={(value: string) => {
              signedEditionSadaicWorkflowStateUpdateStore.setName_esValue(
                value
              );
            }}
            name_es={
              signedEditionSadaicWorkflowStateUpdateStore.entityValues.name_es
            }
            name_enError={
              signedEditionSadaicWorkflowStateUpdateStore.errors.name_en
                ?.message
            }
            onName_enChange={(value: string) => {
              signedEditionSadaicWorkflowStateUpdateStore.setName_enValue(
                value
              );
            }}
            name_en={
              signedEditionSadaicWorkflowStateUpdateStore.entityValues.name_en
            }
            name_ptError={
              signedEditionSadaicWorkflowStateUpdateStore.errors.name_pt
                ?.message
            }
            onName_ptChange={(value: string) => {
              signedEditionSadaicWorkflowStateUpdateStore.setName_ptValue(
                value
              );
            }}
            name_pt={
              signedEditionSadaicWorkflowStateUpdateStore.entityValues.name_pt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={signedEditionSadaicWorkflowStateUpdateStore.saveDisabled}
            onSave={() =>
              signedEditionSadaicWorkflowStateUpdateStore.saveSignedEditionSadaicWorkflowState()
            }
            onCancel={() =>
              signedEditionSadaicWorkflowStateUpdateStore.cancelSignedEditionSadaicWorkflowState()
            }
          />
          <ErrorDialog
            open={signedEditionSadaicWorkflowStateUpdateStore.errorDialogOpened}
            title={signedEditionSadaicWorkflowStateUpdateStore.errorTitle}
            description={
              signedEditionSadaicWorkflowStateUpdateStore.errorDescription
            }
            onClose={() =>
              signedEditionSadaicWorkflowStateUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={
              signedEditionSadaicWorkflowStateUpdateStore.confirmDialogOpened
            }
            title={
              signedEditionSadaicWorkflowStateUpdateStore.confirmDialogTitle
            }
            description={
              signedEditionSadaicWorkflowStateUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              signedEditionSadaicWorkflowStateUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              signedEditionSadaicWorkflowStateUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
